// Synthesized sound of soft fabric/velvet rustling — elegant whisper
let _ctx = null;
function getCtx() {
  if (!_ctx) {
    const AudioCtor = window.AudioContext || window.webkitAudioContext;
    if (!AudioCtor) return null;
    _ctx = new AudioCtor();
  }
  if (_ctx.state === "suspended") _ctx.resume();
  return _ctx;
}

export function playCurtainSwoosh() {
  const ctx = getCtx();
  if (!ctx) return;
  const now = ctx.currentTime;

  // 1. Soft fabric rustle — pink-noise-like with gentle low-pass + amplitude waves
  const rustleDur = 2.2;
  const rustleBuf = ctx.createBuffer(
    1,
    Math.floor(ctx.sampleRate * rustleDur),
    ctx.sampleRate
  );
  const rustleData = rustleBuf.getChannelData(0);
  // Generate "pink-ish" noise (smoothed white noise) for soft, warm character
  let last = 0;
  for (let i = 0; i < rustleData.length; i++) {
    const t = i / ctx.sampleRate;
    const white = Math.random() * 2 - 1;
    // 1-pole low-pass to soften the noise into a velvet-like whisper
    last = last * 0.86 + white * 0.14;
    // Gentle amplitude waves — fabric folds catching air, very subtle
    const wave1 = 0.7 + 0.3 * Math.sin(t * 1.6 * Math.PI);
    const wave2 = 0.85 + 0.15 * Math.sin(t * 5.3 * Math.PI + 1.2);
    rustleData[i] = last * wave1 * wave2 * 0.9;
  }
  const rustleSrc = ctx.createBufferSource();
  rustleSrc.buffer = rustleBuf;

  // Soft band-pass to give it a velvet "shhh" character (not too bright, not muddy)
  const rustleBp = ctx.createBiquadFilter();
  rustleBp.type = "bandpass";
  rustleBp.frequency.value = 1800;
  rustleBp.Q.value = 0.7;

  const rustleHp = ctx.createBiquadFilter();
  rustleHp.type = "highpass";
  rustleHp.frequency.value = 600;

  // Gentle low-pass tail so it never gets harsh
  const rustleLp = ctx.createBiquadFilter();
  rustleLp.type = "lowpass";
  rustleLp.frequency.value = 5500;

  const rustleGain = ctx.createGain();
  rustleGain.gain.setValueAtTime(0, now);
  rustleGain.gain.linearRampToValueAtTime(0.16, now + 0.45);
  rustleGain.gain.linearRampToValueAtTime(0.13, now + 1.4);
  rustleGain.gain.exponentialRampToValueAtTime(0.001, now + rustleDur);

  rustleSrc
    .connect(rustleBp)
    .connect(rustleHp)
    .connect(rustleLp)
    .connect(rustleGain)
    .connect(ctx.destination);
  rustleSrc.start(now);

  // 2. Subtle low "whoosh" of moving fabric (very low-passed noise, slow swell)
  const whooshBuf = ctx.createBuffer(
    1,
    Math.floor(ctx.sampleRate * 1.8),
    ctx.sampleRate
  );
  const whooshData = whooshBuf.getChannelData(0);
  for (let i = 0; i < whooshData.length; i++) {
    whooshData[i] = (Math.random() * 2 - 1) * 0.4;
  }
  const whooshSrc = ctx.createBufferSource();
  whooshSrc.buffer = whooshBuf;
  const whooshLp = ctx.createBiquadFilter();
  whooshLp.type = "lowpass";
  whooshLp.frequency.value = 380;
  whooshLp.Q.value = 0.5;
  const whooshGain = ctx.createGain();
  whooshGain.gain.setValueAtTime(0, now);
  whooshGain.gain.linearRampToValueAtTime(0.07, now + 0.6);
  whooshGain.gain.exponentialRampToValueAtTime(0.001, now + 1.8);
  whooshSrc.connect(whooshLp).connect(whooshGain).connect(ctx.destination);
  whooshSrc.start(now);

  // 3. Tiny silk shimmer near the end — high airy noise (very quiet)
  const shimmerBuf = ctx.createBuffer(
    1,
    Math.floor(ctx.sampleRate * 0.9),
    ctx.sampleRate
  );
  const shimmerData = shimmerBuf.getChannelData(0);
  for (let i = 0; i < shimmerData.length; i++) {
    shimmerData[i] = (Math.random() * 2 - 1) * 0.6;
  }
  const shimmerSrc = ctx.createBufferSource();
  shimmerSrc.buffer = shimmerBuf;
  const shimmerHp = ctx.createBiquadFilter();
  shimmerHp.type = "highpass";
  shimmerHp.frequency.value = 4500;
  const shimmerGain = ctx.createGain();
  shimmerGain.gain.setValueAtTime(0, now + 0.3);
  shimmerGain.gain.linearRampToValueAtTime(0.04, now + 0.8);
  shimmerGain.gain.exponentialRampToValueAtTime(0.001, now + 1.6);
  shimmerSrc.connect(shimmerHp).connect(shimmerGain).connect(ctx.destination);
  shimmerSrc.start(now + 0.3);
}
